/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advanced_Maintenance_Location_Title_ValvesInputs */



/**
* | output |
* | --- |
* | "Thermostatic head location" |
*
* @param {Advanced_Maintenance_Location_Title_ValvesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const advanced_maintenance_location_title_valves = /** @type {((inputs?: Advanced_Maintenance_Location_Title_ValvesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advanced_Maintenance_Location_Title_ValvesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Thermostatic head location")
	return /** @type {LocalizedString} */ ("Localisation de la tête thermostatique")
});